import { Injectable, Optional } from "@angular/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Search } from "../models/search.model";

export const tileUrl = "https://cam.bs.sicodata.no/api/tile/crt";
export const archiveUrl = "https://cam.bs.sicodata.no/api/tile/arch/";

@Injectable()
export class ImageService {
    private _isOK: boolean;
    private _http: Http;
    private headers: Headers;

    constructor(private http: Http) {
        this._http = http;
    }

    private getHttp(url: string): Observable<any> {
        this.onSetHeaders();
        return this._http.get(url, { headers: this.headers });
    }

    private onSetHeaders() {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
    }

    onGetArchive(model: Search): Observable<any> {
        var body = { name: model.name, year: model.year, month: model.month };
        this.onSetHeaders();

        return this._http.post(archiveUrl, JSON.stringify(body), { headers: this.headers });
    }

    onGetTile(): Observable<any> {
        return this.getHttp(tileUrl);
    }
}



// WEBPACK FOOTER //
// C:/pgutev/work/WEBCAM/src/app/service/app.image.service.ts